import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import LicenseRenewalFailCustomerInfoBottomSheet from '@di-shared/features/public-service/license-renewal/LicenseRenewalFailCustomerInfoBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function LicenseRenewalFailCustomerInfoBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <LicenseRenewalFailCustomerInfoBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
